// 身份类型
export const USER_ROLES = {
  STUDENT: 'student',        // 学生
  TEACHER: 'teacher',        // 老师
  PARENT:  'parent',         // 家长
  LEARNER: 'learner'         // 自由学习者
}

// 身份配置
export const ROLE_CONFIG = {
  [USER_ROLES.STUDENT]: {
    label: '学生',
    icon: 'fa-user-graduate',
    color: '#6C63FF',
    bg: '#EEF0FF'
  },
  [USER_ROLES.TEACHER]: {
    label: '老师',
    icon: 'fa-chalkboard-teacher',
    color: '#FF6B6B',
    bg: '#FFF0F0'
  },
  [USER_ROLES.PARENT]: {
    label: '家长',
    icon: 'fa-user-friends',
    color: '#FF9F43',
    bg: '#FFF5E6'
  },
  [USER_ROLES.LEARNER]: {
    label: '自由学习者',
    icon: 'fa-book-open',
    color: '#20BF6B',
    bg: '#F0FFF6'
  }
}

// 科目配置
export const SUBJECTS = [
  { id: 'chinese',  name: '语文', icon: 'fa-language', color: '#E17055' },
  { id: 'math',     name: '数学', icon: 'fa-calculator', color: '#0ABDE3' },
  { id: 'english',  name: '英语', icon: 'fa-globe', color: '#20BF6B' },
  { id: 'physics',  name: '物理', icon: 'fa-atom', color: '#6C63FF' },
  { id: 'chemistry', name: '化学', icon: 'fa-flask', color: '#F9CA24' },
  { id: 'biology',  name: '生物', icon: 'fa-dna', color: '#FF6B6B' },
  { id: 'history',  name: '历史', icon: 'fa-landmark', color: '#A29BFE' },
  { id: 'geography', name: '地理', icon: 'fa-globe-americas', color: '#55efc4' },
  { id: 'politics', name: '政治', icon: 'fa-landmark', color: '#FF9FF3' },
  { id: 'it',       name: '信息技术', icon: 'fa-laptop', color: '#48dbfb' },
  { id: 'music',    name: '音乐', icon: 'fa-music', color: '#F8B739' },
  { id: 'art',      name: '美术', icon: 'fa-palette', color: '#fd79a8' },
  { id: 'pe',       name: '体育', icon: 'fa-running', color: '#26de81' },
  { id: 'technology', name: '通用技术', icon: 'fa-tools', color: '#a29bfe' },
  { id: 'research', name: '研究性学习', icon: 'fa-microscope', color: '#7bed9f' }
]

// 等级配置
export const GRADE_LEVELS = [
  { grade: 'A', label: '优秀', color: '#20BF6B', bg: '#F0FFF6' },
  { grade: 'B', label: '良好', color: '#0ABDE3', bg: '#F0FBFF' },
  { grade: 'C', label: '及格', color: '#F9CA24', bg: '#FFFBF0' },
  { grade: 'D', label: '不及格', color: '#FF6B6B', bg: '#FFF0F0' }
]

// 获取等级
export function getGradeInfo(grade) {
  return GRADE_LEVELS.find(g => g.grade === grade) || GRADE_LEVELS[3]
}

// 作业数据
export const HOMEWORKS = [
  {
    id: 'hw001',
    title: '二次函数练习题',
    subject: 'math',
    teacherId: 't001',
    teacherName: '赵老师',
    content: '请完成以下二次函数练习题，要求写出完整解题过程。\n\n1. 求抛物线 y=x²-4x+3 的顶点坐标\n2. 判断函数 y=2x²-3x+1 的开口方向\n3. 已知抛物线过点(1,2)、(2,5)、(3,10)，求解析式',
    deadline: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [
      { type: 'image', url: 'https://picsum.photos/400/300?random=1', name: '题目图片1.jpg' }
    ],
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: []
  },
  {
    id: 'hw002',
    title: '英语阅读理解练习',
    subject: 'english',
    teacherId: 't001',
    teacherName: 'Emily老师',
    content: '完成以下阅读理解题，限时30分钟。\n\nPassage 1: About environmental protection...',
    deadline: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [],
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: []
  },
  {
    id: 'hw003',
    title: '物理力学计算题',
    subject: 'physics',
    teacherId: 't002',
    teacherName: '张老师',
    content: '完成以下力学计算题，注意单位换算。\n\n1. 一个质量为5kg的物体受到10N的水平力，求加速度\n2. 分析斜面上物体的受力情况',
    deadline: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 已截止
    attachments: [
      { type: 'image', url: 'https://picsum.photos/400/300?random=2', name: '力学示意图.png' }
    ],
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: []
  },
  // 历史作业示例 - 已完成且有成绩
  {
    id: 'hw004',
    title: '唐诗背诵考核',
    subject: 'chinese',
    teacherId: 't001',
    teacherName: '王老师',
    content: '背诵并默写以下唐诗：\n1. 静夜思\n2. 望庐山瀑布\n3. 黄鹤楼送孟浩然之广陵',
    deadline: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [],
    createdAt: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: [
      {
        id: 'sub001',
        studentId: 's001',
        studentName: '小明同学',
        content: '已按时完成背诵任务，默写如下：\n静夜思\n李白\n床前明月光，疑是地上霜。\n举头望明月，低头思故乡。\n\n望庐山瀑布\n李白\n日照香炉生紫烟，遥看瀑布挂前川。\n飞流直下三千尺，疑是银河落九天。\n\n黄鹤楼送孟浩然之广陵\n李白\n故人西辞黄鹤楼，烟花三月下扬州。\n孤帆远影碧空尽，唯见长江天际流。',
        submittedAt: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(),
        grade: 'A',
        comment: '背诵流利，字迹工整，非常优秀！',
        gradedAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString()
      }
    ]
  },
  {
    id: 'hw005',
    title: '完形填空专项训练',
    subject: 'english',
    teacherId: 't001',
    teacherName: 'Emily老师',
    content: '完成以下完形填空题（共10题，每题10分）',
    deadline: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [],
    createdAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: [
      {
        id: 'sub002',
        studentId: 's001',
        studentName: '小明同学',
        content: '1.B 2.A 3.C 4.D 5.B 6.A 7.C 8.B 9.D 10.A',
        submittedAt: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString(),
        grade: 'B',
        comment: '整体不错，第3题和第8题需要加强，注意上下文语境。',
        gradedAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString()
      }
    ]
  },
  {
    id: 'hw006',
    title: '光的折射实验报告',
    subject: 'physics',
    teacherId: 't002',
    teacherName: '张老师',
    content: '完成光的折射实验并撰写实验报告，要求包含：实验目的、实验原理、实验步骤、数据记录与分析、实验结论',
    deadline: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [],
    createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: [
      {
        id: 'sub003',
        studentId: 's001',
        studentName: '小明同学',
        content: '实验报告已提交，包含完整的实验数据和结论分析。',
        submittedAt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        grade: 'A',
        comment: '实验报告写得非常规范，数据分析详尽，继续保持！',
        gradedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString()
      }
    ]
  },
  {
    id: 'hw007',
    title: '有机化学基础测试',
    subject: 'chemistry',
    teacherId: 't003',
    teacherName: '李老师',
    content: '完成以下有机化学基础测试题',
    deadline: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    attachments: [],
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    submissions: [
      {
        id: 'sub004',
        studentId: 's001',
        studentName: '小明同学',
        content: '已完成全部测试题',
        submittedAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
        grade: 'C',
        comment: '基础概念掌握尚可，需要加强官能团性质的记忆。',
        gradedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString()
      }
    ]
  }
]

// 课程数据（K12 学科课程）
export const COURSES = [
  {
    id: 'math-junior',
    cat: '数学',
    stage: '初中',
    title: '初中数学强化训练',
    rating: 4.9,
    students: '12.5k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#6C63FF,#a29bfe)',
    img: 'https://cdn-icons-png.flaticon.com/512/2103/2103635.png',
    videoUrl: '',
    teacher: '李老师',
    teacherSchool: '北京师范大学 · 数学教育硕士',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=mathteacher',
    desc: '系统讲解初中数学核心知识点，涵盖代数、几何、函数、统计与概率，配合典型例题与解题技巧，帮助学生夯实基础、提升解题能力。',
    duration: '18h',
    lessons: 36,
    progress: 45,
    currentLesson: 16,
    highlights: [
      '36 节精讲视频，覆盖初中数学全部考点',
      '每章配套练习题 + 答案解析',
      '典型错题分析，避免常见失分点',
      '期中/期末模拟卷精讲',
    ],
    catalog: [
      { chapter: '第一章：实数与代数式', items: [
        { title: '有理数与无理数', duration: '15:30', free: true },
        { title: '整式加减与乘除', duration: '18:20', free: false },
        { title: '因式分解技巧', duration: '20:10', free: false },
      ]},
      { chapter: '第二章：方程与不等式', items: [
        { title: '一元一次方程', duration: '16:40', free: false },
        { title: '二元一次方程组', duration: '22:05', free: false },
        { title: '一元一次不等式', duration: '14:30', free: false },
      ]},
      { chapter: '第三章：函数基础', items: [
        { title: '平面直角坐标系', duration: '12:00', free: false },
        { title: '一次函数图像与性质', duration: '25:15', free: false },
      ]},
    ],
    reviews: [
      { name: '王同学', avatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=rev1', rating: 5, content: '李老师讲得特别清楚，原来不懂的函数现在终于理解了！期末考试数学提高了15分。', date: '2026-04-10' },
      { name: '张同学', avatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=rev2', rating: 5, content: '题型归纳很到位，每次看完视频再做练习题，效果特别好。', date: '2026-03-28' },
    ],
  },
  {
    id: 'chinese-junior',
    cat: '语文',
    stage: '初中',
    title: '初中语文阅读与作文',
    rating: 4.8,
    students: '9.8k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#E17055,#e17055)',
    img: 'https://cdn-icons-png.flaticon.com/512/2993/2993508.png',
    videoUrl: '',
    teacher: '赵老师',
    teacherSchool: '华东师范大学 · 中文系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=chineseteacher',
    desc: '涵盖初中语文阅读理解技巧、作文写作方法、古诗文鉴赏，帮助学生提升语文综合素养，轻松应对中考。',
    duration: '15h',
    lessons: 30,
    progress: 0,
    currentLesson: 0,
    highlights: ['阅读理解答题模板与技巧', '作文立意与结构设计', '古诗文背诵与鉴赏方法', '中考真题逐题精讲'],
    catalog: [
      { chapter: '第一章：现代文阅读', items: [
        { title: '记叙文阅读技巧', duration: '14:00', free: true },
        { title: '说明文阅读方法', duration: '16:20', free: false },
        { title: '议论文阅读策略', duration: '18:10', free: false },
      ]},
      { chapter: '第二章：作文训练', items: [
        { title: '审题立意与选材', duration: '20:30', free: false },
        { title: '结构设计与语言表达', duration: '22:15', free: false },
      ]},
    ],
    reviews: [],
  },
  {
    id: 'english-junior',
    cat: '英语',
    stage: '初中',
    title: '初中英语语法与听力',
    rating: 4.7,
    students: '8.2k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#20BF6B,#0be881)',
    img: 'https://cdn-icons-png.flaticon.com/512/197/197374.png',
    videoUrl: '',
    teacher: '王老师',
    teacherSchool: '北京外国语大学 · 英语系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=englishteacher',
    desc: '系统讲解初中英语核心语法，配合听力训练与口语练习，帮助学生建立英语语感，全面提升听说读写能力。',
    duration: '14h',
    lessons: 28,
    progress: 0,
    currentLesson: 0,
    highlights: ['八大时态全面解析', '听力技巧与精听训练', '口语发音纠正', '阅读理解提速方法'],
    catalog: [],
    reviews: [],
  },
  {
    id: 'physics-junior',
    cat: '物理',
    stage: '初中',
    title: '初中物理力学与电学',
    rating: 4.8,
    students: '7.5k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#0ABDE3,#48dbfb)',
    img: 'https://cdn-icons-png.flaticon.com/512/3655/3655618.png',
    videoUrl: '',
    teacher: '刘老师',
    teacherSchool: '清华大学 · 物理系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=physicsteacher',
    desc: '生动讲解初中物理力学与电学核心概念，配合实验视频与生活实例，让物理变得有趣又易懂。',
    duration: '12h',
    lessons: 24,
    progress: 0,
    currentLesson: 0,
    highlights: ['力学概念动画演示', '电路实验视频讲解', '公式推导过程详解', '中考物理实验题精讲'],
    catalog: [],
    reviews: [],
  },
  {
    id: 'chemistry-junior',
    cat: '化学',
    stage: '初中',
    title: '初中化学元素与反应',
    rating: 4.7,
    students: '5.6k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#F9CA24,#f0932b)',
    img: 'https://cdn-icons-png.flaticon.com/512/2017/2017318.png',
    videoUrl: '',
    teacher: '陈老师',
    teacherSchool: '中国科学技术大学 · 化学系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=chemistryteacher',
    desc: '从元素周期表入手，系统讲解初中化学核心知识点，配合实验演示，帮助学生建立化学思维。',
    duration: '10h',
    lessons: 20,
    progress: 0,
    currentLesson: 0,
    highlights: ['元素周期表记忆口诀', '化学方程式配平技巧', '实验操作规范演示', '化学计算题专项训练'],
    catalog: [],
    reviews: [],
  },
  {
    id: 'math-senior',
    cat: '数学',
    stage: '高中',
    title: '高中数学函数与导数',
    rating: 4.9,
    students: '15.2k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#6C63FF,#5A52E8)',
    img: 'https://cdn-icons-png.flaticon.com/512/2103/2103635.png',
    videoUrl: '',
    teacher: '张教授',
    teacherSchool: '复旦大学 · 数学系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=mathsrt',
    desc: '深入讲解高中数学函数、导数、数列、立体几何等核心考点，配合高考真题解析，助力高考数学冲刺。',
    duration: '22h',
    lessons: 44,
    progress: 0,
    currentLesson: 0,
    highlights: ['函数性质全面精讲', '导数应用与极值问题', '立体几何空间向量法', '高考真题逐题精讲'],
    catalog: [],
    reviews: [],
  },
  {
    id: 'chinese-senior',
    cat: '语文',
    stage: '高中',
    title: '高中语文古文鉴赏',
    rating: 4.8,
    students: '6.8k',
    price: 0,
    oldPrice: 0,
    color: 'linear-gradient(135deg,#E17055,#d63031)',
    img: 'https://cdn-icons-png.flaticon.com/512/2993/2993508.png',
    videoUrl: '',
    teacher: '孙老师',
    teacherSchool: '北京大学 · 中文系',
    teacherAvatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=chinesesr',
    desc: '系统讲解高中古诗文阅读与鉴赏方法，涵盖必修与选修教材，配合高考真题训练，提升古文阅读能力。',
    duration: '16h',
    lessons: 32,
    progress: 0,
    currentLesson: 0,
    highlights: ['必修古诗文逐篇精讲', '古文翻译技巧训练', '诗歌鉴赏答题模板', '高考真题分类精讲'],
    catalog: [],
    reviews: [],
  },
]

// 分类配置
export const CATEGORIES = [
  { name: '编程',  icon: 'fa-code',                 bg: '#EEF0FF', color: '#6C63FF' },
  { name: '设计',  icon: 'fa-pen-nib',              bg: '#FFF0F0', color: '#FF6B6B' },
  { name: '语言',  icon: 'fa-language',             bg: '#F0FFF6', color: '#20BF6B' },
  { name: '数学',  icon: 'fa-square-root-variable', bg: '#FFFBF0', color: '#F9CA24' },
  { name: '科学',  icon: 'fa-flask',                bg: '#F0FBFF', color: '#0ABDE3' },
  { name: '职场',  icon: 'fa-briefcase',            bg: '#FFF4F0', color: '#E17055' },
  { name: '艺术',  icon: 'fa-palette',              bg: '#FDF0FF', color: '#A29BFE' },
]

// 用户数据
export const USER = {
  name: '小明同学',
  avatar: 'https://api.dicebear.com/8.x/avataaars/svg?seed=user123',
  level: 7,
  streak: 23,
  totalHours: 86,
  completedCourses: 1,
  todayMinutes: 43,
  goalMinutes: 60,
  weekData: [40, 65, 30, 85, 72, 50, 20], // 百分比
}

// Banner 数据
export const BANNERS = [
  {
    id: 'python',
    tag: '限时特惠',
    title: 'Python 数据分析\n精品课程',
    sub: '从零基础到项目实战',
    bg: 'linear-gradient(135deg,#6C63FF,#5A52E8)',
    img: 'https://cdn-icons-png.flaticon.com/512/5968/5968350.png',
  },
  {
    id: 'ui',
    tag: '新课上线',
    title: 'UI/UX 设计\n全套教程',
    sub: '让你的设计作品开口说话',
    bg: 'linear-gradient(135deg,#FF6B6B,#EE5A24)',
    img: 'https://cdn-icons-png.flaticon.com/512/3246/3246683.png',
  },
  {
    id: 'english',
    tag: '热门推荐',
    title: '英语口语\n进阶训练',
    sub: 'AI对话练口语，高效又有趣',
    bg: 'linear-gradient(135deg,#20BF6B,#26de81)',
    img: 'https://cdn-icons-png.flaticon.com/512/197/197374.png',
  },
]
